import { UpdateStatusPriority } from '@models/UpdateStatus.model';

export const getUpdateFlagColor = (
  priority: UpdateStatusPriority | null,
): string => {
  if (priority === UpdateStatusPriority.IMPORTANT) return '#FF9900';
  if (priority === UpdateStatusPriority.NONCRITICAL) return '#52BD94';
  if (priority === UpdateStatusPriority.URGENT) return '#D14343';
  return '#C1C4D6';
};
